import type { ComponentProps } from 'solid-js'
import { splitProps } from 'solid-js'

const VARIANT_CLASSES = {
   primary: 'btn-accent text-white',
   secondary: 'bg-surface-control-hover text-ink hover:bg-surface-control',
   warning: 'border border-amber-300/70 text-amber-100 transition hover:bg-amber-400/15',
   danger: 'border border-rose-400/70 text-rose-100 transition hover:bg-rose-500/15',
} as const

export type ButtonVariant = keyof typeof VARIANT_CLASSES

type ButtonProps = ComponentProps<'button'> & {
   variant?: ButtonVariant
}

/**
 * Renders a themed action button. Defaults to `type="button"` so buttons
 * inside forms do not submit unless they opt in with `type="submit"`.
 *
 * @param props - Standard button props plus the visual variant.
 * @returns The button element.
 */
const Button = (props: ButtonProps) => {
   const [local, rest] = splitProps(props, ['variant', 'class'])
   return (
      <button
         type="button"
         {...rest}
         class={[
            'rounded-control py-3 font-bold',
            VARIANT_CLASSES[local.variant ?? 'primary'],
            local.class,
         ]
            .filter(Boolean)
            .join(' ')}
      />
   )
}

export default Button
